import { render, staticRenderFns } from "./ChooseColor.vue?vue&type=template&id=c3f4446a"
import script from "./ChooseColor.vue?vue&type=script&lang=js"
export * from "./ChooseColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyaboktober/65379/65/Stoffe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3f4446a')) {
      api.createRecord('c3f4446a', component.options)
    } else {
      api.reload('c3f4446a', component.options)
    }
    module.hot.accept("./ChooseColor.vue?vue&type=template&id=c3f4446a", function () {
      api.rerender('c3f4446a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/stoffe/ChooseColor.vue"
export default component.exports